import script from "./MfaSmsConfirmForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaSmsConfirmForm.vue?vue&type=script&setup=true&lang=ts"

import "./MfaSmsConfirmForm.vue?vue&type=style&index=0&id=49832420&lang=css"

const __exports__ = script;

export default __exports__